//@flow
import React from 'react';
import classnames from 'classnames';
import { themr, type ThemeType } from 'react-css-themr';
import Switch from 'react-toolbox/lib/switch';
import theme from './Switch.scss';

type Props = {
    checked: boolean,
    onChange: boolean => void,
    label: ?string,
    color: string,
    disabled?: boolean,
    name?: string,
    invert?: boolean,
    onBlur?: () => void,
    onFocus?: () => void,
    testId?: string,
    className?: string,
    theme: ThemeType
};

type DefaultProps = {
    color: string
};
class SwitchComponent extends React.Component<Props, void> {
    static defaultProps: DefaultProps = {
        color: 'dark-sky-blue'
    };

    onChange = (...args) => {
        const { onChange, fieldId } = this.props;
        if (fieldId) {
            onChange && onChange(fieldId, ...args);
        } else {
            onChange && onChange(...args);
        }
    };

    render() {
        const {
            checked,
            className,
            disabled,
            label,
            name,
            onBlur,
            onFocus,
            theme,
            color,
            invert,
            testId
        } = this.props;
        return (
            <Switch
                testId={testId}
                checked={checked}
                className={classnames(className, {
                    [theme[color]]: color,
                    [theme.invert]: invert
                })}
                disabled={disabled}
                label={label}
                name={name}
                onBlur={onBlur}
                onChange={this.onChange}
                onFocus={onFocus}
                theme={theme}
            />
        );
    }
}

const ThemedSwitchComponent = themr('SwitchComponent', theme)(SwitchComponent);

export { ThemedSwitchComponent as SwitchComponent };
export default ThemedSwitchComponent;
